import { FunctionComponent, memo } from 'react';
import { getCssVar } from '../../utils';
import { IconLabel } from '../IconLabel';

import classNames from 'classnames';
import classes from './Avatar.module.scss';

interface AvatarProps {
  url?: string | null;
  size?: number;
  className?: string;
  nonClickable?: boolean;
  onClick?: () => void;
  fallBackIconId?: string;
  ariaLabel?: string;
}

export const Avatar: FunctionComponent<AvatarProps> = memo(
  ({ url, size = 40, className, nonClickable, onClick, fallBackIconId = 'avatar', ariaLabel }) => {
    if (!url) {
      return (
        <div className={classNames(className, classes['avatar'])}>
          <IconLabel
            iconId={fallBackIconId}
            iconSize={size}
            color={getCssVar('--avatar-background-color')}
            nonClickable={nonClickable}
            onClick={onClick}
            ariaLabel={ariaLabel}
            singleColor
          />
        </div>
      );
    }

    const isClickable = Boolean(onClick) && !nonClickable;

    const Tag = isClickable ? 'button' : 'div';

    return (
      <Tag
        className={classNames(className, classes['avatar'], {
          [classes['avatar--clickable']]: !nonClickable,
        })}
        style={{
          backgroundImage: `url(${url})`,
          minWidth: `${size}px`,
          width: `${size}px`,
          height: `${size}px`,
        }}
        onClick={onClick}
        {...(isClickable && { type: 'button', 'aria-label': ariaLabel })}
      ></Tag>
    );
  }
);
